import { render, staticRenderFns } from "./bankaccount.vue?vue&type=template&id=75ba354c&scoped=true&"
import script from "./bankaccount.vue?vue&type=script&lang=js&"
export * from "./bankaccount.vue?vue&type=script&lang=js&"
import style0 from "./bankaccount.vue?vue&type=style&index=0&id=75ba354c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ba354c",
  null
  
)

export default component.exports